import {JsonObject, JsonProperty} from "typescript-json-serializer";
import {FieldInfoConfiguration} from "../core/config/field-info-configuration";

@JsonObject()
export class StationInfoRowConfiguration {

    /**
     * Base IDs for whom this row configuration should be used
     */
    @JsonProperty()
    declare baseIds: number[];

    /**
     * Description for this configuration
     */
    @JsonProperty()
    declare description: string;

    /**
     * Definition of fields
     */
    @JsonProperty()
    declare fields: FieldInfoConfiguration[];

    constructor() {
    }
}

@JsonObject()
export class StationInfoConfiguration {

    @JsonProperty()
    declare rows: StationInfoRowConfiguration[];

    constructor() {
    }

    /**
     * Get row configuration by station base ID
     *
     * @param baseId
     */
    row(baseId: number): StationInfoRowConfiguration | undefined {
        return this.rows.find((row: StationInfoRowConfiguration) => row.baseIds.includes(baseId));
    }
}
